export default "__VITE_PUBLIC_ASSET__adc80b7c__"